"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchMeterReadingAuditQuery = exports.useFetchFlaggedReadingsQuery = exports.useCorrectMeterReadingMutation = exports.useFlagMeterReadingMutation = exports.useFetchMeterReadingQuery = exports.useFetchLatestReadingQuery = exports.useSearchMeterReadingsQuery = exports.useUpdateMeterReadingMutation = exports.useCreateMeterReadingMutation = exports.meterReadingApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
// ─── API ─────────────────────────────────────────────────────────────────────
exports.meterReadingApi = (0, react_1.createApi)({
    reducerPath: "meterReadingApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["meter_readings", "meter_reading_audits"],
    endpoints: function (builder) { return ({
        createMeterReading: builder.mutation({
            query: function (formData) { return ({
                url: "/v1/meter-reading/create",
                method: "POST",
                body: formData,
            }); },
            invalidatesTags: ["meter_readings"],
        }),
        searchMeterReadings: builder.query({
            query: function (obj) {
                var params = {
                    clientId: obj.clientId,
                    buildingId: obj.buildingId,
                    page: obj.page || 1,
                    limit: obj.limit || 10,
                };
                if (obj.search)
                    params.search = obj.search;
                if (obj.meterId)
                    params.meterId = obj.meterId;
                if (obj.meterType)
                    params.meterType = obj.meterType;
                if (obj.billingPeriod)
                    params.billingPeriod = obj.billingPeriod;
                if (obj.source)
                    params.source = obj.source;
                if (obj.status)
                    params.status = obj.status;
                if (obj.captureMethod)
                    params.captureMethod = obj.captureMethod;
                if (obj.flagged !== undefined)
                    params.flagged = obj.flagged;
                return {
                    url: "/v1/meter-reading/all",
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["meter_readings"],
        }),
        fetchLatestReading: builder.query({
            query: function (obj) { return ({
                url: "/v1/meter-reading/latest",
                method: "GET",
                params: { clientId: obj.clientId, meterId: obj.meterId },
            }); },
        }),
        fetchMeterReading: builder.query({
            query: function (readingId) { return ({
                url: "/v1/meter-reading/fetch",
                method: "GET",
                params: { _id: readingId },
            }); },
            providesTags: ["meter_readings"],
        }),
        flagMeterReading: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/meter-reading/flag",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["meter_readings", "meter_reading_audits"],
        }),
        correctMeterReading: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/meter-reading/correct",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["meter_readings", "meter_reading_audits"],
        }),
        fetchFlaggedReadings: builder.query({
            query: function (obj) {
                var params = {
                    clientId: obj.clientId,
                    page: obj.page || 1,
                    limit: obj.limit || 50,
                };
                if (obj.buildingId)
                    params.buildingId = obj.buildingId;
                return {
                    url: "/v1/meter-reading/flagged",
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["meter_readings"],
        }),
        updateMeterReading: builder.mutation({
            query: function (formData) { return ({
                url: "/v1/meter-reading/update",
                method: "PUT",
                body: formData,
            }); },
            invalidatesTags: ["meter_readings", "meter_reading_audits"],
        }),
        fetchMeterReadingAudit: builder.query({
            query: function (obj) {
                var params = {};
                if (obj.usageId)
                    params.usageId = obj.usageId;
                if (obj.clientId)
                    params.clientId = obj.clientId;
                if (obj.limit)
                    params.limit = obj.limit;
                if (obj.offset)
                    params.offset = obj.offset;
                return {
                    url: "/v1/meter-reading/audit",
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["meter_reading_audits"],
        }),
    }); },
});
exports.useCreateMeterReadingMutation = exports.meterReadingApi.useCreateMeterReadingMutation, exports.useUpdateMeterReadingMutation = exports.meterReadingApi.useUpdateMeterReadingMutation, exports.useSearchMeterReadingsQuery = exports.meterReadingApi.useSearchMeterReadingsQuery, exports.useFetchLatestReadingQuery = exports.meterReadingApi.useFetchLatestReadingQuery, exports.useFetchMeterReadingQuery = exports.meterReadingApi.useFetchMeterReadingQuery, exports.useFlagMeterReadingMutation = exports.meterReadingApi.useFlagMeterReadingMutation, exports.useCorrectMeterReadingMutation = exports.meterReadingApi.useCorrectMeterReadingMutation, exports.useFetchFlaggedReadingsQuery = exports.meterReadingApi.useFetchFlaggedReadingsQuery, exports.useFetchMeterReadingAuditQuery = exports.meterReadingApi.useFetchMeterReadingAuditQuery;
